// extracted by mini-css-extract-plugin
export default {"top":"style_top__9tjN+","profile":"style_profile__qHPa6","image":"style_image__rF-d9","name":"style_name__rWa2Y","Shouts":"style_Shouts__q21UG","options":"style_options__Syavs"};